<div class="layout-wrapper" jmlGlobalClick>
  <jml-topbar></jml-topbar>

  <jml-sidebar></jml-sidebar>

  <div
    class="layout-main"
    data-cy="layout-main-div"
    [ngClass]="{
      'layout-main-desktop-sidebar-inactive': sidebarDesktopInactive,
      'layout-main-mobile-sidebar-inactive': !sidebarMobileActive
    }"
  >
    <div class="layout-main-content">
      <jml-lib-notifications></jml-lib-notifications>
      <jml-lib-script-result></jml-lib-script-result>
      <router-outlet></router-outlet>
    </div>
  </div>

  <jml-footer class="layout-footer"></jml-footer>
</div>
